var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllPlatforms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41211 10.8906V14.0917C7.41211 14.5075 7.66936 14.8799 8.05822 15.027L16.0582 18.054C16.2863 18.1403 16.538 18.1403 16.766 18.054L24.766 15.027C25.1549 14.8799 25.4121 14.5075 25.4121 14.0917V10.8906",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9121 12L16.0582 13.5688C16.2863 13.6551 16.538 13.6551 16.766 13.5688L20.9121 12",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41211 12.3516C7.41211 12.3516 7.41211 11.7049 7.41211 11.0964C7.41211 10.6806 7.66936 10.3083 8.05822 10.1611L16.0582 7.13411C16.2863 7.04783 16.538 7.04783 16.766 7.13411L24.766 10.1611C25.1549 10.3083 25.4121 10.6807 25.4121 11.0964L25.4121 11.8651",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41211 17.7031V20.9042C7.41211 21.32 7.66936 21.6924 8.05822 21.8395L16.0582 24.8665C16.2863 24.9528 16.538 24.9528 16.766 24.8665L24.766 21.8395C25.1549 21.6924 25.4121 21.32 25.4121 20.9042V17.7031",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41211 19.1641C7.41211 19.1641 7.41211 18.4316 7.41211 17.7922C7.41211 17.4367 7.60089 17.1079 7.90795 16.9287L9.91211 15.7587M25.4121 18.6776L25.4121 17.7923C25.4121 17.4367 25.2233 17.1079 24.9163 16.9287L22.9121 15.7587",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPlatforms);
export default __webpack_public_path__ + "static/media/AllPlatforms.fbc338b25f93658b090fcafd86213777.svg";
export { ForwardRef as ReactComponent };